import type { GoodsDiscountGroupItem } from 'shared/src/api';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useCallback } from 'react';
import { getStackableCouponEnabled } from 'shared/src/hooks';

export const useLogCompleteDownloadCoupon = (item: GoodsDiscountGroupItem) => {
  const logGoodsAnalyticsEvent = useLogGoodsAnalyticsEvent();

  return useCallback(async () => {
    const enableStackableCoupon = await getStackableCouponEnabled();

    logGoodsAnalyticsEvent({
      name: 'COMPLETE_DOWNLOAD_COUPON',
      analytics: {
        ...item.logging.analytics,
        COUPON_NAME: item.title,
        COUPON_SNO: item.detail?.sno.toString(),
        ENABLE_STACKABLE_COUPON: enableStackableCoupon ? '1' : '0',
        IS_DOWNLOAD_ALL: '0',
      },
    });
  }, [item, logGoodsAnalyticsEvent]);
};
